import { Button } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
import GenericBenchmarkEditor from './GenericBenchmarkEditor';
import GenericBenchmark from '../../../../../../models/data/GenericBenchmark';
const GenericBenchmarkPicker = ({ initial, setInitialBenchmark }) => {
    const [benchmark, setBenchmark] = React.useState(initial ?? new GenericBenchmark({ swap: { side: 'MID' } }));
    const onChangeBenchmark = React.useCallback((event) => {
        setBenchmark(event.target.value);
    }, []);
    const onClickBenchmarkSave = React.useCallback(() => {
        setInitialBenchmark(benchmark);
    }, [benchmark, setInitialBenchmark]);
    return (React.createElement("div", { style: { display: 'flex', marginTop: '0.5rem', } },
        React.createElement("div", { style: { border: 'outline', marginRight: '0.5rem', padding: '0.25rem', borderRadius: '0.25rem', boxShadow: 'inset 0 0 0 0.125rem var(--tk-input-color-default, #8f959e)' } },
            React.createElement(GenericBenchmarkEditor, { onChange: onChangeBenchmark, value: benchmark })),
        React.createElement(Button, { onClick: onClickBenchmarkSave, style: { alignSelf: 'center' } }, "OK")));
};
export default GenericBenchmarkPicker;
